export default {
  routerList: [
    {
      path: '/sugSolicitation',
      redirect: '/sugSolicitationHomePage'
    },
    {
      path: '/sugSolicitationHomePage',
      component: () => import('@/views/sugSolicitation/sugSolicitation/sugSolicitationHomePage/index.vue'),
      meta: { keepAlive: true },
      name: '人民建议征集首页',
      children: []
    },
    {
      path: '/sugSolicitationHomePage/addSug',
      component: () => import('@/views/sugSolicitation/sugSolicitation/sugSolicitationHomePage/addSug.vue'),
      meta: { keepAlive: true },
      name: '添加建言',
      children: []
    },
    {
      path: '/sugSolicitationHomePage/collectList',
      component: () => import('@/views/sugSolicitation/sugSolicitation/sugSolicitationHomePage/collectList.vue'),
      meta: { keepAlive: true },
      name: '征集公告列表',
      children: []
    },
    {
      path: '/sugSolicitationHomePage/heatedDebateDetails',
      component: () => import('@/views/sugSolicitation/sugSolicitation/sugSolicitationHomePage/heatedDebateDetails.vue'),
      meta: { keepAlive: true },
      name: '群众热议详情',
      children: []
    },
    {
      path: '/solicitingSubmissions',
      component: () => import('@/views/sugSolicitation/sugSolicitation/solicitingSubmissions/index.vue'),
      meta: { keepAlive: true },
      name: '正在征集',
      children: []
    },
    {
      path: '/popularDiscussion',
      component: () => import('@/views/sugSolicitation/sugSolicitation/popularDiscussion/index.vue'),
      meta: { keepAlive: true },
      name: '群众热议',
      children: []
    },
    {
      path: '/achievementTransformation',
      component: () => import('@/views/sugSolicitation/sugSolicitation/achievementTransformation/index.vue'),
      meta: { keepAlive: true },
      name: '成果转化',
      children: []
    },
    {
      path: '/suggestionVideo',
      component: () => import('@/views/sugSolicitation/sugSolicitation/suggestionVideo/index.vue'),
      meta: { keepAlive: true },
      name: '建言视频',
      children: []
    },
    {
      path: '/suggestionsFromNetizens',
      component: () => import('@/views/sugSolicitation/sugSolicitation/suggestionsFromNetizens/index.vue'),
      meta: { keepAlive: true },
      name: '网民建言',
      children: []
    },
    {
      path: '/suggestedSelection',
      component: () => import('@/views/sugSolicitation/sugSolicitation/suggestedSelection/index.vue'),
      meta: { keepAlive: true },
      name: '建议选登',
      children: []
    },
    {
      path: '/classicCase',
      component: () => import('@/views/sugSolicitation/sugSolicitation/classicCase/index.vue'),
      meta: { keepAlive: true },
      name: '典型案例',
      children: []
    },
    {
      path: '/sugNewList',
      component: () => import('@/views/sugSolicitation/sugSolicitation/sugNewList.vue'),
      meta: { keepAlive: true },
      name: '人民建议征集新闻列表',
      children: []
    },
    {
      path: '/sugNewDetails',
      component: () => import('@/views/sugSolicitation/sugSolicitation/sugNewDetails.vue'),
      meta: { keepAlive: true },
      name: '人民建议征集新闻详情',
      children: []
    },
    {
      path: '/sugSolicitaDetails',
      component: () => import('@/views/sugSolicitation/sugSolicitation/sugSolicitaDetails.vue'),
      meta: { keepAlive: true },
      name: '人民建议征集详情',
      children: []
    },
  ]
}
